import Callback from './auth/Callback.vue';
import LightningDatabases from './lightning/LightningDatabases.vue';
import Login from './auth/Login.vue';
import ModelPublish from './modelPublish/ModelPublish.vue';
import Router from 'vue-router';
import ServiceQueues from './servicequeues/ServiceQueues.vue';
import Vue from 'vue';
import WorkflowsComponent from './workflows/Workflows.vue';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/modelpipeline',
    },
    {
      path: '/modelpipeline/:jobId?/:activityEventId?',
      name: 'Model Pipeline',
      component: ModelPublish,
    },
    {
      path: '/lightning/:jobId?/:activityEventId?',
      name: 'Lightning',
      component: ModelPublish,
      props: { lightning: true },
    },
    {
      path: '/lightningdatabases/:companyId?',
      name: 'Lightning Databases',
      component: LightningDatabases,
    },
    {
      path: '/lightningcatalogs/:jobId?/:activityEventId?',
      name: 'Lightning Catalogs',
      component: ModelPublish,
      props: { lightningCatalogs: true },
    },
    {
      path: '/packagePublishes/:jobId?/:activityEventId?',
      name: 'Package Publishes',
      component: ModelPublish,
      props: { packagePublishes: true },
    },
    {
      path: '/workflows',
      name: 'Workflows',
      component: WorkflowsComponent,
    },
    {
      path: '/servicequeues',
      name: 'Service Queues',
      component: ServiceQueues,
    },
    {
      path: '/callback',
      name: 'Callback',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Callback,
      //  import(/* webpackChunkName: "about" */ '@/auth/Callback.vue')
    },
    {
      path: '/login',
      name: 'Login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Login,
      //  import(/* webpackChunkName: "about" */ '@/auth/Login.vue')
    },
    {
      path: '*',
      redirect: '/modelpipeline',
    },
  ],
});

export default router;
